export interface GetOneV2Dto {
  include?: string;
}
